module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-50.d3b8cb20.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-50.png
// module id = 3312
// module chunks = 11